import { featureCards } from '@/mocks/categories';

export default function WhyUseSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 text-center mb-3">
          Why Use Superbuy Spreadsheet?
        </h2>
        <p className="text-foreground-500 text-center mb-12 text-sm md:text-base max-w-2xl mx-auto">
          Thousands of shoppers trust the Superbuy Spreadsheet to find better products faster. Here is what makes it the ultimate resource.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featureCards.map((card) => (
            <div
              key={card.title}
              className="group p-6 md:p-8 rounded-2xl bg-background-100 border border-foreground-100/60 hover:border-accent-300/60 transition-all duration-300 cursor-default"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-5 group-hover:bg-accent-200 transition-colors duration-300">
                <i className={`${card.icon} text-xl text-accent-700 w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-3">{card.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}